import React, { Component } from 'react'
import { connect } from 'react-redux'
import { InputError, Button } from '@foodsby/nutrient'

import {
  updateAndSaveUserLocationStart,
  updateUserLocationTemporarily,
} from '../../redux/modules/user'
import {
  LocationBuilding,
  Location,
  LocationContainer,
} from '../common/Location'
import { SimpleSpinner } from '../common/SimpleSpinner'

export class UpdateUserLocationPanel extends Component {
  render() {
    const {
      locationId,
      updateUserLocationTemporarily,
      updateAndSaveUserLocationStart,
      updateUserLocationError,
      location = {},
      isLocationLoading,
    } = this.props
    return (
      <div className="row center-xs">
        <div className="col-xs-12">
          <h3>Would you like to make this your default location?</h3>
          {isLocationLoading ? (
            <SimpleSpinner />
          ) : (
            <div className="row center-xs">
              <Location
                style={{
                  marginTop: '15px',
                  marginBottom: '25px',
                  marginRight: '50px',
                }}
              >
                <LocationContainer style={{ textAlign: 'left' }}>
                  <LocationBuilding
                    address={location.address}
                    name={location.deliveryLocationName}
                    showLink={false}
                  />
                </LocationContainer>
              </Location>
            </div>
          )}
          <div className="row">
            <div className="col-xs-6 middle-xs">
              <Button
                className="secondary"
                onClick={() => updateUserLocationTemporarily(locationId)}
              >
                No, just browsing
              </Button>
            </div>
            <div className="col-xs-6 middle-xs">
              <Button
                className="secondary"
                onClick={() => updateAndSaveUserLocationStart(locationId)}
              >
                Yes, update now
              </Button>
            </div>
            {updateUserLocationError && (
              <div className="row center-xs">
                <InputError
                  visible={
                    updateUserLocationError && updateUserLocationError !== null
                  }
                >
                  {updateUserLocationError.message
                    ? updateUserLocationError.message
                    : 'Oops! Something went wrong. If this continues to happen, please contact support.'}
                </InputError>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { updateUserLocationError } = state.user
  const { isLocationLoading, location } = state.location
  return {
    updateUserLocationError,
    location,
    isLocationLoading,
  }
}

const mapDispatchToProps = {
  updateUserLocationTemporarily,
  updateAndSaveUserLocationStart,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateUserLocationPanel)
